import { io } from "socket.io-client";

const URL_WPP = `${process.env.VUE_APP_WS_URL}/wpp-auth`;
const socket = io(URL_WPP, { autoConnect: false, transports: ['websocket'] });

/*socket.onAny((event, ...args) => {
  console.log('WPP Event',event, args);
});*/

export default socket;
